import { EDITBOOK } from "./actionTypes";

export const editingBook = (bookData) => {
 return {
  type: EDITBOOK,
  payload: bookData,
 };
};
